// Shared display constant. Catalog, orders and staff authentication use the API.
export const CURRENCY = '\u20B9';
